import { combineGuardsParallel } from '../../composer/combineGuardsParallel';
import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
// guard list
import { checkMaintenanceGuard } from '../../guards/checkMaintenanceGuard';
import { checkUnscopeGuard } from '../../guards/checkUnscopeGuard';
import { determineAccessibleProjectGuard } from '../../guards/determineAccessibleProjectGuard';
import { determineBaseInfoGuard } from '../../guards/determineBaseInfoGuard';
import { determineConsoleVersionInitialGuard } from '../../guards/determineConsoleVersionInitialGuard';
import { determineDomainDetailInfoGuard } from '../../guards/determineDomainDetailInfoGuard';
import { determineDomainGuard } from '../../guards/determineDomainGuard';
import { determineFavoriteServiceGuard } from '../../guards/determineFavoriteServiceGuard';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';
import { determineLanguageGuard } from '../../guards/determineLanguageGuard';
import { determineMegaMenuGuard } from '../../guards/determineMegaMenuGuard';
import { determineProjectGuard } from '../../guards/determineProjectGuard';
import { determineRecentServiceGuard } from '../../guards/determineRecentServiceGuard';
import { determineRegionGuard } from '../../guards/determineRegionGuard';
import { determineUserPreferenceGuard } from '../../guards/determineUserPreferenceGuard';
import { generateBaseTokenGuard } from '../../guards/generateBaseTokenGuard';
import { generateDomainTokenGuard } from '../../guards/generateDomainTokenGuard';
import { generateProjectTokenGuard } from '../../guards/generateProjectTokenGuard';
import { preloadBrowserI18nResourceGuard } from '../../guards/preloadBrowserI18nResourceGuard';
import { suggestRegionGuard } from '../../guards/suggestRegionGuard';
import { validateQueryGuard } from '../../guards/validateQueryGuard';

import type { AnyOfGuard } from '../../../types';

const baseGuardArray = [
  combineGuardsSerial([preloadBrowserI18nResourceGuard, determineConsoleVersionInitialGuard]),
  combineGuardsSerial([generateBaseTokenGuard, determineI18nResourceGuard]),
  combineGuardsParallel([checkMaintenanceGuard, determineBaseInfoGuard]),
  combineGuardsSerial([
    // common
    validateQueryGuard,
    determineAccessibleProjectGuard,
    determineLanguageGuard,
    suggestRegionGuard,
    // un-scope
    checkUnscopeGuard,
    // domain-scope
    determineDomainGuard,
    generateDomainTokenGuard,
    // project-scope
    determineProjectGuard,
    generateProjectTokenGuard,
    determineRegionGuard,
  ]),
  combineGuardsParallel([
    determineDomainDetailInfoGuard,
    determineFavoriteServiceGuard,
    determineRecentServiceGuard,
    determineMegaMenuGuard,
    determineUserPreferenceGuard,
  ]),
];

export const generateInitialServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  return combineGuardsSerial([...baseGuardArray, combineGuardsSerial(additionalGuards || [])]);
};
